import forEach from 'lodash/forEach';

import { getDateString, getDateTimeString } from '@/exceed';

export default ({ data, isLiveVideo = false, isAgenda = false }) => {
  const orderedContentList = {
    rootId: 'root',
    items: {
      root: {
        id: 'root',
        hasChildren: true,
        isExpanded: true,
        isChildrenLoading: false,
        data: { title: 'root' },
        children: [],
      },
    },
  };

  const createOrderedItem = ({ item }) => {
    orderedContentList.items.root.children.push(item.id);

    const startAt = isAgenda
      ? `${item?.start_date}T${item?.start_time}Z` // agenda items always returned as UTC
      : item?.start_at;

    const orderedItem = {
      id: item.id,
      isChildrenLoading: false,
      hasChildren: false,
      isExpanded: false,
      children: [],
      parentId: 'root',
      data: {
        ...item,
        ...(isLiveVideo && { type: 'video' }),
        ...(isAgenda && { type: 'agenda' }),
        title: item.name,
        formattedUpdatedAt: getDateString(item?.updated_at),
        formattedStartAt: getDateTimeString(startAt),
      },
    };

    orderedContentList.items[item.id] = orderedItem;

    return orderedItem.id;
  };

  forEach(data.data, (item) => createOrderedItem({ item }));

  return orderedContentList;
};
